

















































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Management extends Vue {
  loading = false;

  menu = [
    {
      title: "Attrattività",
      subtitle: "",
      to: "/management-attractiveness",
    },
    {
      title: "Accesso alla destinazioni",
      subtitle: "",
      to: "/management-destination-access",
    },
    {
      title: "Accoglienza",
      subtitle: "",
      to: "/management-hospitality",
    },
  ];

  onSurveyTypeClick(to: string) {
    this.$router.push(to).catch(error => console.log(error));
  }
}
